<template>
  <v-card
    class="mb-3"
    :class="getWaltClassObject(assignedWalt)">
    <v-card-title
      v-if="assignedWalt.subject !== 'General' && hideWorkingTowards !== true"
      class="pb-0 caption font-italic">
      <span v-if="assignedWalt.complete">Achieved</span>
      <!-- <span v-else>Working Towards</span> -->
      <span v-else>
        <template v-if="customTitleWt!==''">
          {{ customTitleWt }}
        </template>
        <template v-else>
          Working Towards
        </template>
      </span>
    </v-card-title>

    <v-card-title class="font-weight-bold subtitle-2">
      {{ assignedWalt.full_descript }}
    </v-card-title>

    <v-expansion-panels
      :value="[0]"
      accordion
      multiple
      v-if="assignedWalt.learning.length > 0">

      <v-expansion-panel
        :class="getWaltClassObject(assignedWalt)">

        <v-expansion-panel-header class="font-weight-bold">
          Learning
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-actions>
            <v-btn
              v-if="typeof assignedWalt.taskid !== 'undefined' && taskIdUsed != ''"
              outlined
              small
              @click.native="hideTaskWalts(assignedWalt.taskid)"

            >
              HIDE {{ showWaltButtonName }}
            </v-btn>

          </v-card-actions>

          <template v-if="typeof assignedWalt.taskid !== 'undefined' && assignedWalt.taskid == taskIdUsed">
            <v-card-text
              v-for="(skillsDesc, eachId) in skillNamesArr"
              :key="eachId"
              v-html="skillsDesc"
            />
          </template>

          <v-card-actions>
            <v-spacer/>
            <v-btn
              v-if="typeof assignedWalt.taskid !== 'undefined' && taskIdUsed == ''"
              outlined
              small
              @click.native="showTaskWalts(assignedWalt.taskid)"

            >
              SHOW {{ showWaltButtonName }}
            </v-btn>

            <v-btn
              v-if="typeof assignedWalt.taskid !== 'undefined' && taskIdUsed != ''"
              outlined
              small
              @click.native="hideTaskWalts(assignedWalt.taskid)"

            >
              HIDE {{ showWaltButtonName }}
            </v-btn>

          </v-card-actions>

          <v-card
            v-for="(tempArr, indx) in assignedWalt.learning"
            :key="indx"
            color="white"
            class="mb-3 elevation-0">
            <li v-if="typeof tempArr !== 'undefined' && checkContentType(tempArr)">
              <v-card-text
                v-if="assignedWalt.subject === 'Specialists'"
                class="font-weight-bold">Student Self-Assessment ({{ tempArr.formattedDate }})</v-card-text>
              <v-card-text
                v-else
                class="font-weight-bold">On {{ tempArr.formattedDate }} your child posted:</v-card-text>
              <!-- <v-divider/> -->
              <v-card-text
                v-if="tempArr.comment !== ''"
                style="overflow-wrap: break-word;"
                v-html="convertURLsToHref(tempArr.comment)"
                class="pb-0"/>
              <v-card-text
                v-else
                class="pb-0"/>

              <v-card-text
                v-for="(urlArr, indof) in tempArr.media"
                :key="indof"
                class="pl-0 pr-0 pb-0 text-center">
                <v-lazy>
                  <v-img
                    v-if="isImage(urlArr.extension)"
                    :src="urlArr.url"/>
                  <video
                    v-if="isVideo(urlArr.extension)"
                    width="50%"
                    controls
                    autoplay
                    playsinline
                    muted
                    :src="urlArr.url"
                  />
                  {{ urlArr.extension }}
                  <v-btn
                    :href="urlArr.url"
                    class="mt-3 mb-3"
                    target="_blank"
                    style="text-decoration: none;"
                    v-if="!isImage(urlArr.extension) && !isVideo(urlArr.extension)">
                    <span>Open {{ getFileExtension(urlArr.extension) }} <v-icon>fa-external-link-alt</v-icon></span>
                  </v-btn>
                </v-lazy>

              </v-card-text>

              <v-card-text
                v-if="tempArr.media.length === 0"
                class="pt-0"/>
              <v-divider v-if="tempArr.teacherComment.length !== 0"/>
              <v-card-text
                style="overflow-wrap: break-word;"
                v-if="tempArr.teacherComment.length !== 0"
                class="">
                <span
                  v-if="assignedWalt.subject === 'Specialists'"
                  :class="{ 'black--text': tempArr.teacherComment.type === 'Teacher',
                            'green--text': tempArr.teacherComment.type === 'Parent' }"><b>Teacher Assessment - {{ tempArr.teacherComment.author }}: </b>  {{ tempArr.teacherComment.content }}</span>
                <span
                  v-else
                  :class="{ 'black--text': tempArr.teacherComment.type === 'Teacher',
                            'green--text': tempArr.teacherComment.type === 'Parent' }"><b>{{ tempArr.teacherComment.author }}</b>  {{ tempArr.teacherComment.content }}</span>
              </v-card-text>
            </li>
            <li v-else>
              <v-card-text style="overflow-wrap: break-word;">
                <span
                  :class="{ 'black--text': tempArr.type === 'Teacher',
                            'green--text': tempArr.type === 'Parent' }">{{ tempArr.content }}</span> <b> - Posted {{ tempArr.formattedDate }} by {{ tempArr.author }}</b>
              </v-card-text>
            </li>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-expansion-panels
      :value="[0, 1]"
      multiple
      v-if="typeof skillEE[assignedWalt.skillid] !== 'undefined'">
      <v-expansion-panel
        v-for="(eeObj, eeTitle) in skillEE[assignedWalt.skillid]"
        :key="eeTitle"
        :class="getWaltClassObject(assignedWalt)">
        <div
          slot="header"
          class="font-weight-bold">{{ eeTitle + 's' }}</div>
        <v-card
          v-for="(ee, i) in eeObj"
          :key="i"
          color="white"
          class="mb-3 elevation-0">
          <v-card-text>
            <v-img
              v-if="ee.absolute_path.includes('images.etap.co.nz') && isImage(ee.absolute_path)"
              class="mr-0"
              max-width="500"
              alt="Exercise/Example Image"
              :src="ee.absolute_path"/>
            <v-btn
              :href="fixURLHttpPrefix(ee.absolute_path)"
              target="_blank"
              style="text-decoration: none;"
              v-else>
              <span>Open Link <v-icon>fa-external-link-alt</v-icon></span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card-actions>
      <span class="caption pl-2 font-italic">Assigned {{ assignedWalt.date_started }}</span>
      <span
        class="caption pl-2 font-italic"
        v-if="assignedWalt.date_completed !== '0000-00-00' && assignedWalt.complete === 1">Completed {{ assignedWalt.date_completed }}</span>
      <v-spacer/>
      <v-tooltip
        v-if="enableCommentButton && typeof assignedWalt.taskid!=='undefined'"
        top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="openFeedbackDialog(assignedWalt.psid, assignedWalt.taskid)">
            <v-icon>comment</v-icon>
          </v-btn>
        </template>
        <span v-if="allowComment">Post Comment</span>
        <span v-else>Feedback</span>
      </v-tooltip>

      <v-tooltip
        v-if="enableCommentButton && typeof assignedWalt.taskid === 'undefined'"
        top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="openFeedbackDialog(assignedWalt.psid, 0)">
            <v-icon>comment</v-icon>
          </v-btn>
        </template>
        <span v-if="allowComment">Post Comment</span>
        <span v-else>Feedback</span>
      </v-tooltip>

    </v-card-actions>
  </v-card>
</template>

<script>
import VLazyImage from '../components/VLazyImage.vue'

export default {
  components: {
    VLazyImage
  },
  props: {
    assignedWalt: {
      type: Object,
      default: function () {
        return {}
      }
    },
    skillEE: {
      type: Object,
      default: function () {
        return {}
      }
    },
    enableCommentButton: {
      type: Boolean,
      default: true
    },
    allowComment: {
      type: Boolean,
      default: true
    },
    hideWorkingTowards: {
      type: Boolean,
      default: false
    },
    customTitleWt: {
      type: String,
      default: ''
    },
    showWaltButtonName: {
      type: String,
      default: 'Show WALTs'
    }
  },

  data: () => ({
    skillNamesArr: [],
    taskIdUsed: ''
  }),

  methods: {
    hideTaskWalts: function (assignedWaltTaskId) {
      this.skillNamesArr = []
      this.taskIdUsed = ''
    },
    showTaskWalts: function (assignedWaltTaskId) {
      this.skillNamesArr = []
      this.$http.get('pupils/' + this.$store.state.pupilId + '/tasks/' + assignedWaltTaskId)
        .then(resp => {
          this.skillNamesArr = resp.data.taskSkillNames
          this.taskIdUsed = resp.data.taskIdUsed
        })
    },
    getWaltClassObject: function (assignedWalt) {
      return {
        'green accent-1': assignedWalt.complete === 1,
        'grey lighten-4': assignedWalt.complete === 0
      }
    },

    checkContentType: function (variable) {
      var checkVal = false
      if ('media' in variable) { checkVal = true }
      return checkVal
    },

    fixURLHttpPrefix: function (stringToFix) {
      return stringToFix.replace(/(http)?(s)?(:\/\/)?(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, 'http$2://$4')
    },

    convertURLsToHref: function (stringToConvert) {
      return stringToConvert.replace(/(http)(s)?(:\/\/)(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, "<a href='http$2://$4' class='v-btn theme--light' style='text-decoration: none;' target='_blank' title='$&'>Open Link</a><br>")
    },

    isImage: function (stringToCheck) {
      var imageExtensions = ['.png', '.jpeg', '.jpg', '.gif']
      return imageExtensions.some(imgExt => stringToCheck.toLowerCase().includes(imgExt.toLowerCase()))
    },

    isVideo: function (stringToCheck) {
      var imageExtensions = ['.MOV', '.MP4', '.AVI', '.OGG', '.MPV', '.AMV']
      return imageExtensions.some(imgExt => stringToCheck.toUpperCase().includes(imgExt.toUpperCase()))
    },

    // escapeHtml: function (text) {
    //   var map = {
    //     '&': '&amp;',
    //     '<': '&lt;',
    //     '>': '&gt;',
    //     // '"': '&quot;',
    //     "'": '&#039;'
    //   }
    //   return text.replace(/[&<>']/g, function (m) { return map[m] })
    // },

    getFileExtension: function (string) {
      return string.split('.').pop()
    },

    openFeedbackDialog: function (psid, taskid) {
      this.$emit('open-feedback-dialog', psid, taskid)
    }
  }
}
</script>

<style scoped>
.v-expansion-panel:before { box-shadow: none !important; }
</style>
